<template>
  <div :class="['activity-feed-item', { 'activity-feed-item-new': isNew(feed.createdAt) }]">
    <b-row>
      <b-col cols="12" md="auto" class="activity-feed-item-icon">
        <template v-if="feed.type===CATEGORY_TYPE.KUDO">
          <avatar
            :variant="feed.giver ? feed.giver.type : 'user'"
            :src="giverPhoto"
            size="2.5rem"
            v-b-tooltip.hover
            :title="giverName"
          />
          <b-icon-hexagon-fill font-scale=".8" class="activity-feed-item-hex" />
        </template>
        <avatar
          :variant="receiver ? receiver.type : 'user'"
          :src="receiverPhoto"
          size="2.5rem"
          v-b-tooltip.hover
          :title="receiverName"
        />
      </b-col>
      <b-col>
        <b-row class="align-items-center m-2 m-md-0">
          <b-col cols="12" md>
            <div class="date-label">
              {{ date(feed.createdAt) }}
            </div>
            <div :class="['font-size-sm', { 'font-weight-bold': isNew(feed.createdAt) }]">
              {{ feed.content }}
            </div>
          </b-col>
          <b-col cols="6" md="auto" order="2" order-md="1" class="pt-2 pb-2">
            <b-button
              v-if="feed.canSayHi && !showMessage"
              variant="primary"
              @click="showMessage = !showMessage"
            >
              Say hi
            </b-button>
            <slack-icon v-if="feed.sentViaSlack" class="ml-2" />
            <ms-teams-icon v-if="feed.sentViaMs" class="ml-2" :style="{fontSize: '1.5rem'}" />
          </b-col>
          <b-col cols="12" md="3" order="1" order-md="2" class="text-md-center pt-2 pb-2">
            <message-type :type="feed.type" :button="collapsible" :multiple="collapsed" @click="$emit('type-click', $event)" />
          </b-col>
        </b-row>
        <b-collapse v-if="feed.canSayHi" :visible="showMessage">
          <b-row class="mt-4">
            <b-col>
              <slot
                name="send-message"
                v-bind="{ close: closeSendMessage, feed, receiver: messageReceiver, receiverName }"
              />
            </b-col>
          </b-row>
        </b-collapse>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment'
import { BIconHexagonFill } from 'bootstrap-vue'
import MessageType from '@/components/common/MessageType'
import Avatar from '@/components/common/Avatar'
import { CATEGORY_TYPE, RECEIVER_TYPE } from '@/helpers/types'
import { userName } from '@/helpers/helpers'
import SlackIcon from '@/assets/images/channels/slack.svg'
import MsTeamsIcon from '@/assets/images/channels/ms-teams.svg'

export default {
  name: 'ActivityFeedItem',

  props: {
    feed: {
      type: Object,
      default: () => ({})
    },

    collapsed: {
      type: Boolean,
      default: false
    },

    collapsible: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    receiver() {
      return this.feed.receiver ? this.feed.receiver : this.feed.giver
    },

    receiverPhoto() {
      return (this.receiver || {}).photo
    },

    receiverName() {
      if (!this.receiver) return ''
      switch (this.receiver.type) {
        case 'user': return userName(this.receiver)
        case 'team': return this.receiver.name
        default: return ''
      }
    },

    giverPhoto() {
      return (this.feed.giver || {}).photo
    },

    giverName() {
      if (!this.feed.giver) return ''
      switch (this.feed.giver.type) {
        case 'user': return userName(this.feed.giver)
        case 'team': return this.feed.giver.name
        default: return ''
      }
    },

    messageReceiver() {
      return { type: RECEIVER_TYPE.USER, receiver: this.receiver }
    }
  },

  data() {
    return {
      CATEGORY_TYPE,
      showMessage: false
    }
  },

  methods: {
    date: date => moment(date).fromNow(),

    isNew(date) {
      const createdAt = moment(date)
      return moment().diff(createdAt, 'minutes') < 10
    },

    closeSendMessage() {
      this.showMessage = false
    }
  },

  components: {
    MessageType,
    Avatar,
    BIconHexagonFill,
    SlackIcon,
    MsTeamsIcon
  }
}
</script>
